import { Alert as MuiAlert, AlertProps as MuiAlertProps, styled } from "@mui/material";

const StyledAlert = styled(MuiAlert)(({ theme }) => {
  return {
    backgroundColor: theme.palette.alertInfo.background,
    color: theme.palette.alertInfo.textColor,
  };
});

interface AlertProps extends MuiAlertProps {
  children: React.ReactNode;
}

export const SecondaryAlert: React.FC<AlertProps> = ({ children, ...props }) => {
  return <StyledAlert {...props}> {children}</StyledAlert>;
};

export default SecondaryAlert;
